import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useEventTracking from 'EventTracking/useEventTrackingLogEvent';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Edit from 'Icons/Edit';

const styles = (theme) => ({
  root: {
    marginLeft: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    borderLeft: `1px solid ${theme.palette.facet.lightGray2}`,
  },
  button: {
    fontWeight: theme.typography.fontWeightBold,
  },
});

const EditMessageButton = ({
  className,
  classes,
  toggleEditMessageInput,
  disableEdit,
  ButtonProps,
}) => {
  const { logEvent } = useEventTracking();

  // Handle Edit Message
  const handleEditMessage = () => {
    logEvent('User selected to edit their message.');
    toggleEditMessageInput();
  };

  return (
    <div
      className={classNames(classes.root, className)}
    >
      <Button
        className={classes.button}
        color={'primary'}
        size={'small'}
        onClick={handleEditMessage}
        disabled={disableEdit}
        variant={'text'}
        startIcon={<Edit />}
        {...ButtonProps}
      >
        {'Edit message'}
      </Button>
    </div>
  );
};

EditMessageButton.defaultProps = {
  className: '',
  ButtonProps: {},
};

EditMessageButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  toggleEditMessageInput: PropTypes.func.isRequired,
  disableEdit: PropTypes.bool.isRequired,
  ButtonProps: PropTypes.object,
};

export default withStyles(styles)(EditMessageButton);
